import { API_FRAUD_CASES } from "../../utils/apis";

export function submitFraudCase(payload: any, id: string) {
  // Clean payload to match expected API format
  const cleanedPayload = {
    title: payload.title,
    description: payload.description,
    events: Array.isArray(payload.events) ? payload.events : [payload.events],
    alerts: Array.isArray(payload.alerts) ? payload.alerts : [],
    severity: payload.severity,
    estimated_loss: payload.estimated_loss,
    team: payload.team,
  };

  if (id) {
    return {
      id,
      api: API_FRAUD_CASES,
      params: cleanedPayload,
    };
  }
  return {
    api: API_FRAUD_CASES,
    params: cleanedPayload,
  };
}
